module.exports = __webpack_public_path__ + "img/load-rawk-5.c4d89905.gif";